import React, {Component} from 'react';

export default class StoreMarker extends Component {


    shouldComponentUpdate(){
        return false;
    }

    render() {
        return (
            <div className={'map-store map-store-holder'}></div>
        );
    }

}